import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import CustomerSearch from '../../../../components/InviteToCallModal/customer-search';
import Toggle from '../../../../components/toggle/toggle';
import { setStandaloneCartUser } from '../../../../reducers/user-reducer';

import "./client-search-tab.scss";

const ClientSearchTab = ({ visible, navigateToStandaloneCartTab }) => {
      const [isLoading, setIsLoading] = useState(false);
      const [isAnonymousMode, setIsAnonymousMode] = useState(false);
      const [customer, setCustomer] = useState(null);
      const [email, setEmail] = useState('');
      const customerName = useRef(null);

      const dispatch = useDispatch();

      const shopId = useSelector((state) => state.shops.activeShopId);
      const standaloneCartUser = useSelector((state) => state.user?.standaloneCartUser);

      useEffect(() => {
            if (visible && standaloneCartUser) {
                  setIsAnonymousMode(standaloneCartUser.anonymousMode || false);
                  setEmail(standaloneCartUser.email || '');
                  setCustomer(standaloneCartUser.customer || null);
                  customerName.current = standaloneCartUser.customer || null;
            }
      }, [visible, standaloneCartUser]);

      const onCustomerChanged = (value) => {
            setCustomer(value ? value.value : null);
            customerName.current = value ? value.value : null;
            if (value && value.value.id) {
                  // value is a search result object
                  setEmail(value.value.email);
                  customerName.current = value.value.displayName;
            }
      };

      const handleSubmit = async (e, email, customer) => {
            e.preventDefault();
            setIsLoading(true);
            dispatch(setStandaloneCartUser({
                  email: isAnonymousMode ? '' : email,
                  customer: isAnonymousMode ? null : customer,
                  anonymousMode: isAnonymousMode
            }));

            navigateToStandaloneCartTab();
            setIsLoading(false);
      };

      const onToggleClick = () => {
            setIsAnonymousMode((prevState) => {
                  const newAnonymousMode = !prevState;

                  if (newAnonymousMode) {
                        setEmail('');
                        setCustomer(null);
                        customerName.current = null;
                  }

                  dispatch(setStandaloneCartUser({
                        email: newAnonymousMode ? '' : email,
                        customer: newAnonymousMode ? null : customer,
                        anonymousMode: newAnonymousMode
                  }));

                  return newAnonymousMode;
            });
      };

      return (
            <div className={`client-search-tab${visible ? ' visible' : ''}`}>
                        <div className='anonymous-mode-container'>
                              <label>
                                    <span className='toggle-message'>Create unassigned cart</span>
                              </label>
                              <Toggle isChecked={isAnonymousMode} toggleFunc={onToggleClick} />
                        </div>

                        <CustomerSearch
                              isStandaloneCartMode
                              isStandaloneCartModeAnonymousUser={isAnonymousMode}
                              isLoading={isLoading}
                              customer={customer}
                              email={email}
                              setEmail={setEmail}
                              onCustomerNameChanged={onCustomerChanged}
                              shopId={shopId}
                              handleSubmit={handleSubmit}
                        />
            </div>
      )
}

export default ClientSearchTab;
